<template>
  <div>
    <p>
      <a
        target="_blank"
        href="https://about.storycity.app/creator-agreement-community-content-guidelines/"
        >
        {{ $t('becomeACreator.pleaseReadTerms')}}
        </a>
    </p>
    <ApolloMutation :mutation="BECOME_CREATOR" @done="result => { proceed(result) }">
      <template v-slot="{ mutate, loading, error }">
        <v-btn :loading="loading" @click="mutate" :disabled="loading" color="primary">{{
          $t("register.acceptTheTerms")
        }}</v-btn>
        <v-alert class="mt-5" v-if="error" type="error">
          {{ error ? error : '' }}
        </v-alert>
      </template>
    </ApolloMutation>
  </div>
</template>
<script>
import { BECOME_CREATOR } from "@/graphql/UserQueries";
export default {
  computed: {
    BECOME_CREATOR() {
      return BECOME_CREATOR;
    },
  },
  methods: {
    proceed(result) {
      if (result.data.becomeCreatorUser.user.isVerified) {
        this.$router.push({ name: "become-creator-next-steps" });
      }
      else {
        this.$router.push({ name: "become-creator-verify" });
      }
    },
  }
}
</script>